export const PERMS = {
  PORTAL_GERENCIAR: 'PORTAL_GERENCIAR',
  BI_VER: 'BI_VER',
  SITE_METADADOS_EDITAR: 'SITE_METADADOS_EDITAR',
  MATRICULA_VER_VALOR_ND: 'MATRICULA_VER_VALOR_ND',
  MATRICULA_ALTERAR_VALOR: 'MATRICULA_ALTERAR_VALOR',
  MATRICULA_REEMITIR_COBRANCA: 'MATRICULA_REEMITIR_COBRANCA',
  PRECO_PARCEIROS_EDITAR: 'PRECO_PARCEIROS_EDITAR',
  PARCEIRO_GERENCIAR: 'PARCEIRO_GERENCIAR',
  PARCEIRO_CONFIG_NEWDRIVER: 'PARCEIRO_CONFIG_NEWDRIVER',
  NOTA_FISCAL_GERENCIAR: 'NOTA_FISCAL_GERENCIAR',
  ALUNO_VER: 'ALUNO_VER',
  CURSO_GERENCIAR: 'CURSO_GERENCIAR',
  TURMA_GERENCIAR: 'TURMA_GERENCIAR',
  CERTIFICADO_GERENCIAR: 'CERTIFICADO_GERENCIAR',
  CUPOM_GERENCIAR: 'CUPOM_GERENCIAR',
  DETRAN_OPERAR: 'DETRAN_OPERAR',
  SENHA_MASTER_VER: 'SENHA_MASTER_VER',
} as const

export const PERFIS_ACESSO = {
  ADMINISTRADOR: 'ADMINISTRADOR',
  SUPORTE: 'SUPORTE',
  CONTEUDO: 'CONTEUDO',
} as const
